import { render, staticRenderFns } from "./Psbio.vue?vue&type=template&id=380daf95&scoped=true"
import script from "./Psbio.vue?vue&type=script&lang=js"
export * from "./Psbio.vue?vue&type=script&lang=js"
import style0 from "./Psbio.vue?vue&type=style&index=0&id=380daf95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380daf95",
  null
  
)

export default component.exports